<div
  class="notification-bell-wrapper cursor-pointer position-relative"
  [ngbPopover]="popoverContent"
  [directivePopoverConfig]="popoverConfig"
  popoverClass="notifications-popover-wrapper"
  autoClose="outside"
  triggers="manual"
  placement="bottom-end"
  (click)="onTogglePopover()">
  <lucide-icon [img]="BellIcon" size="20" class="text-secondary" />
  @if (unreadCount() > 0) {
    <span class="position-absolute top-0 start-100 translate-middle p-1 bg-success border border-light rounded-circle">
      <span class="visually-hidden">New alerts</span>
    </span>
  }
</div>

<ng-template #popoverContent>
  <div class="notifications-popup rounded-5">
    <div class="d-flex align-items-center justify-content-between p-3 border-bottom header">
      <h6 class="m-0 fw-semibold">Notifications</h6>
      @if (notifications().length > 0) {
        <button
          class="btn btn-link btn-sm p-0 text-decoration-none text-muted"
          (click)="markAllAsRead()"
          title="Mark all as read">
          <lucide-icon [img]="CheckAllIcon" size="16" />
        </button>
      }
    </div>

    <div class="notifications-list">
      @if (loading()) {
        <div class="p-4 text-center text-muted">Loading...</div>
      } @else if (notifications().length === 0) {
        <div class="p-4 text-center text-muted">
          <div class="mb-2">🎉</div>
          <small>No new notifications</small>
        </div>
      } @else {
        @for (notif of notifications(); track notif.id) {
          <div
            class="notification-item p-3 border-bottom cursor-pointer"
            [class.unread]="!notif.isRead"
            (mouseenter)="onHover(notif)"
            (click)="handleNotificationClick(notif)">
            <div class="d-flex gap-3">
              <div class="flex-grow-1">
                <div class="d-flex justify-content-between align-items-start mb-1">
                  <span class="fw-semibold text-sm">{{ notif.title }}</span>
                  <div class="d-flex align-items-center gap-2">
                    <span class="text-xs text-muted">{{ notif.createdAt | date: "short" }}</span>
                    @if (!notif.isRead) {
                      <span class="unread-dot bg-success rounded-circle"></span>
                    }
                  </div>
                </div>
                <p class="text-sm text-muted m-0 text-wrap">{{ notif.message }}</p>
              </div>
              <div class="actions d-flex flex-column gap-1">
                <button class="btn btn-icon btn-sm text-danger" (click)="deleteNotification(notif.id, $event)">
                  <lucide-icon [img]="CloseIcon" size="14" />
                </button>
              </div>
            </div>
          </div>
        }
      }
    </div>
  </div>
</ng-template>
